import React from "react";
import Col from '../Col';
import Row from '../Row';
import PropTypes from "prop-types";

const Legende = (props) => {
    const {
        onMouseOut,
        children
    } = props;

    const style = {
        zIndex: '1000',
        position: 'absolute',
        bottom: '45px',
        left: '10px',
        backgroundColor: 'white',
        padding: '12px',
        width: '300px',
        boxShadow: '-4px 4px 18px #4d4a4a',
        borderRadius: '5px'
    };

    return <div onMouseOut={onMouseOut}>
        <div style={style}>
            <Col size={12}>
                {children}
            </Col>
        </div>
        <div className="background"></div>
    </div>;
};

Legende.propTypes = {
    onMouseOut: PropTypes.func,
    children: PropTypes.node
};

export default Legende;